import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  /** Defaults to the pricing section. Only the pricing card links to checkout. */
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/** Coral (Floor) is the single action colour on this page. */
export function CtaButton({
  children,
  href = '#offer',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-5 text-lg sm:text-xl rounded-2xl min-h-[64px]' : 'px-5 py-3 text-sm rounded-xl';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!href.startsWith('#')) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduce ? 'auto' : 'smooth',
      block: 'start'
    });
  };
  return <a href={href} onClick={handleClick} className={`inline-flex w-full items-center justify-center gap-2 bg-coral-deep text-center font-display font-extrabold tracking-tight text-white shadow-card transition-[background-color,box-shadow] duration-150 ease-out hover:bg-coral hover:shadow-lift focus:outline-none focus-visible:ring-4 focus-visible:ring-amber/70 ${sizing} ${className}`} data-id="element-88" data-mp="15a9cl1zh4367">
      {children}
    </a>;
}